/**
 * Append UTM params to an outbound, human-clicked link (JS mirror of the
 * backend's services.utils.with_utm).
 *
 * Only for links we hand to a share action / deep link — NEVER for internal
 * navigation or anything Google indexes. The page's canonical is built from
 * the path only, so UTM'd variants still consolidate to the clean URL.
 *
 * Uses URLSearchParams.set, so re-tagging overwrites the utm_* keys instead of
 * duplicating them — a page reached via a UTM'd link and then re-shared gets
 * re-attributed to the sharer's channel, not double-appended.
 *
 * @param {string} url - absolute URL to tag
 * @param {string} source - platform/mechanism: whatsapp | native | copy | ...
 * @param {string} medium - mechanism: share_button
 * @param {string} [campaign] - optional grouping: piek | melding
 * @param {string} [content] - optional utm_content (e.g. alert id)
 * @returns {string} tagged URL
 */
export function withUtm(url, source, medium, campaign, content) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('utm_source', source);
    u.searchParams.set('utm_medium', medium);
    if (campaign) u.searchParams.set('utm_campaign', campaign);
    if (content) u.searchParams.set('utm_content', content);
    return u.toString();
}
